import { CotopaxiPaddings, CotopaxiBorders } from './CommonTypes';

export enum NewsletterSubscribeFeedbackTypes {
  ALREADY_SUBSCRIBED = 'alreadySubscribed',
  ERROR = 'error',
  SUCCESS = 'success',
}

export type NewsletterSubscribeContainerProps = {
  paddings?: CotopaxiPaddings;
  borders: CotopaxiBorders;
  title: string;
  buttonLabel: string;
  redirectUrl: string;
};
